import Title from "antd/es/typography/Title"
import Structure from "../Structure"
import { Button, Card, Col, Divider, Row, message } from 'antd';
import { useState } from "react";
import HelperModal from "../../subComponents/general/helperModal";
import CrearNuevoRegistro from "./crear";
import { rutas } from "../../lib/routes/routes";
import { Link } from "react-router-dom";
import { FileExcelFilled } from "@ant-design/icons";
import ListadoRegistros from "./listado";
import { main_data } from "./data";
import { useDispatch, useSelector } from "react-redux";
import { urlapi } from "../../lib/backend/data";
import { cerrarSesion } from "../../redux/actions/sesion";

const Costos = (props) => {
    const {
        default_payload,
        showCreateButton,
        showImportButton,
        titulo,
        display_full,
        showClientSelector,
        condicion,
        showFilters,
        showCustomFieldsData
    } = props
    const [ condicion_busqueda, setCondicionBusqueda ] = useState(condicion ? condicion : {})
    const [ loading, setLoading ] = useState(false)
    const sesion = useSelector(state => state.miusuario)
    const [ messageApi, contextHolder] = message.useMessage();
    const dispatch = useDispatch()
    const modulo = main_data.module

    const onSelect = (datos,action) => {
        if(!action) return
        const i = componentes_accion.findIndex(it => it.label === action)
        console.log({ i, action })
        if(i > -1){
            const funcion = componentes_accion[i].action
            funcion(datos)
        }
    }

    const eliminarMultiples = async (viajes)=>{
        setLoading(true)

        const seleccionados = viajes.map(e => e._id)
        return fetch(`${urlapi}/${modulo}/masive`,{
            method:'DELETE',
            body: JSON.stringify({
                ids: seleccionados
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${sesion.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                messageApi.error('Sin datos')
            } else if(res.errorMessage){
                messageApi.error(res.errorMessage)
            } else if(res.deletedCount){
                return window.location.reload()
            }
            return setLoading(false)
        })
        .catch(error => {
            messageApi.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })
    }
    
    const componentes_accion = [
        {
            label: "ELIMINAR",
            action: eliminarMultiples
        }
    ]

    const mostrarBotonCreacion = () => {
        if(showCreateButton === false) return false
        return <div>
            <Row gutter={15}>
              <Col span="auto">
                <CrearNuevoRegistro 
                    showClientSelector={showClientSelector} 
                    default_payload={default_payload ? default_payload : {}} 
                    onCreate={() => {
                        console.log('condicion', condicion)
                        setCondicionBusqueda({...{}, ...condicion })
                    } }
                /></Col>
              { showImportButton === false ? false :  <Col span="auto"><Button style={{ marginRight: 10 }} size="small"><Link to={rutas.import_products.slug}><FileExcelFilled /> IMPORTADOR</Link></Button></Col> }
              <Col span="auto"><HelperModal tipo={modulo} style="modal" /></Col>
            </Row>
            <Divider />
        </div>
    }
    
    const render = () => {
        return <div>
            { titulo ? <Title className="mb-2 mt-0">{titulo}</Title> : false }
            {mostrarBotonCreacion()}
            <ListadoRegistros 
                showSelection={true} 
                onSelect={(data,action) => onSelect(data,action)} 
                loadingActions={loading}
                componentAction={componentes_accion}
                showFilters={showFilters} 
                showCustomFieldsData={showCustomFieldsData} 
                condicion_default={condicion_busqueda} 
            />
        </div>
    }

    if(display_full === true ){

        const renderizar = <div><Card>{render()}</Card></div>

        return <Structure component={renderizar} />
    } else {
        return render()
    }
}

export default Costos